import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoKey24 = t0 => {
  const $ = _c(10);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] !== iconColor) {
    t2 = <path d="M14.9167 13.875C17.563 13.875 19.7083 11.7297 19.7083 9.08335C19.7083 6.43699 17.563 4.29169 14.9167 4.29169C12.2703 4.29169 10.125 6.43699 10.125 9.08335C10.125 9.48495 10.1744 9.87499 10.2675 10.2478L5.36908 15.1461C5.2128 15.3024 5.125 15.5144 5.125 15.7354V18.0418C5.125 18.5019 5.4981 18.8751 5.95833 18.8751H8.26467C8.48568 18.8751 8.69764 18.7873 8.85393 18.631L9.70833 17.7766V15.5418H11.9432L13.7523 13.7326C14.1251 13.8256 14.5151 13.875 14.9167 13.875Z" stroke={iconColor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M16.3752 9.08333C16.3752 9.88875 15.7222 10.5417 14.9168 10.5417C14.1114 10.5417 13.4585 9.88875 13.4585 9.08333C13.4585 8.27792 14.1114 7.625 14.9168 7.625C15.7222 7.625 16.3752 8.27792 16.3752 9.08333Z" stroke={iconColor} strokeWidth={1.5} strokeLinecap="square" />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2 || $[8] !== t3) {
    t4 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default IcoKey24;